import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import filterList from 'website/containers/lists/filterlist';
import searchTheaterPush from 'website/containers/theaters/search-theater-push';
import userOpinion from 'website/containers/user-action/UserOpinionBannerEntry';
import userRating from 'website/containers/user-action/userRating';
import userWantToSee from 'website/containers/user-action/userWantToSee';
import affinityBadge from 'website/containers/user/affinityBadge';
import affinitySuggestions from 'website/containers/user/affinitySuggestions';
import userFriendsRating from 'website/containers/user/userFriendsRating';
import initAnimatedPoster from 'website/module/advertisement/animated-poster';
import initCarouselVideo from 'website/module/advertisement/carousel-video';
import loadAnchorPlus from 'website/module/anchor/anchor-plus';
import initPlayer from 'website/module/player';
import carousel from 'website/module/ui/carousel';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import initRollerAuto from 'website/module/ui/roller-auto';
import selectChange from 'website/module/ui/select-change';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initPlayer();

  carousel();
  initCarouselVideo();

  thirdNav();

  dropdownLinks();

  searchTheaterPush();

  filterList();

  selectChange();

  roller();
  initRollerAuto();

  // Social user Action
  userFriendsRating();
  facebookWidgets();

  initAnimatedPoster();

  // Social modules based on Redux
  userRating();
  userWantToSee();
  affinitySuggestions();
  userOpinion();
  socialActionsBootstrap().then(() => {
    // to avoid having a display skip.
    // the macaron is loaded after the social request
    affinityBadge();
  });

  loadAnchorPlus();
});
